import { MRT_ColumnDef } from "material-react-table";
import { CustomSearch, EstadoComponente } from "@/shared/components/ui";
import {
  usefetchTiketUsers,
} from "@/shared/actions/erp/tiketUsers";
import { useCheckPermissions, useTableFilter } from "@/shared/hooks";
import GeneralTable from "@/shared/components/ui/GeneralTable";
import { EstadosTiketUserEnum, TiketUsers } from "@/shared/interfaces";
import { Avatar, Box, Grid } from "@mui/material";
import { useMemo } from "react";
import { PermissionsEnum } from "@/auth/interfaces";

export default function TiketsUsuariosAprobadosPagina() {

  useCheckPermissions(PermissionsEnum.api_view_ticketuser);

  const columns = useMemo<MRT_ColumnDef<TiketUsers>[]>(
    () => [
      {
        accessorKey: "codigo",
        header: "codigo",
        size: 200,
      },
      {
        accessorKey: "descripcion",
        header: "descripcion",
        size: 200,
      },
      {
        accessorKey: "empresa_data.razon_social",
        header: "empresa",
        size: 200,
      },
      {
        accessorKey: "area_data.nombre",
        header: "area",
        size: 200,
      },
      {
        accessorKey: "estado_ticket",
        header: "estado",
        size: 200,
        Cell: ({ row }) => (
          row.original.estado_ticket != null ?
            <EstadoComponente backgroundColor="green" texto={row.original.estado_ticket || ''} /> : null
        ),
      },
      {
        accessorKey: "imagenes.photosTicket",
        header: "imagen 1",
        size: 200,
        Cell: ({ row }) => {
          return (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
              }}
            >
              {row.original.imagenes?.photosTicket?.imagen1 && (
                <Avatar
                  sx={{
                    height: 40,
                    width: 40,
                  }}
                  src={row.original.imagenes?.photosTicket?.imagen1.url}
                  alt="imagen 1"
                />
              )}
            </Box>
          );
        },
      },
      {
        accessorKey: "imagenes.photosTicket",
        header: "imagen 1",
        size: 200,
        Cell: ({ row }) => {
          return (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
              }}
            >
              {row.original.imagenes?.photosTicket?.imagen2 && (
                <Avatar
                  sx={{
                    height: 40,
                    width: 40,
                  }}
                  src={row.original.imagenes?.photosTicket?.imagen2.url}
                  alt="imagen 1"
                />
              )}
            </Box>
          );
        },
      },
      {
        accessorKey: "departamento_data.nombre",
        header: "departamento",
        size: 200,
      },
      {
        accessorKey: "fecha_creacion",
        header: "fecha creacion	",
        size: 200,
      },

    ],
    []
  );

  const {
    globalFilter,
    pagination,
    searchTerm,
    onChangeFilter,
    setPagination,

  } = useTableFilter();

  const { pageIndex } = pagination;

  const {
    isLoading,
    data: TiketUserAprobadosRes,
    isRefetching,
  } = usefetchTiketUsers({
    page: pageIndex + 1,
    nombre_requerimento: searchTerm,
    estado_ticket: EstadosTiketUserEnum.FINALIZADO
  });

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <CustomSearch
          onChange={onChangeFilter}
          value={globalFilter}
          text=""
        />
      </Grid>
      <Grid item xs={12}>
        <GeneralTable<TiketUsers>
          columns={columns}
          data={TiketUserAprobadosRes?.data.data || []}
          //
          isLoading={isLoading}
          isRefetching={isRefetching}
          // // search
          enableGlobalFilter={false}
          // onGlobalFilterChange={setGlobalFilter}
          // // pagination
          pagination={pagination}
          onPaging={setPagination}
          rowCount={TiketUserAprobadosRes?.data?.count}
          // // actions
          enableColumnActions={false}
          enableEditing={false}
          canDelete={false}
          positionActionsColumn='first'
        />
      </Grid>
    </Grid>

  );
}
